export const shiyong_url =
  "https://t22qshgkpd.jiandaoyun.com/f/68cb68e880eabb692970b84a";
